/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import { Toast } from "@react/react-spectrum/Toast";
import Styles from "./index.css";
import classNames from "classnames";

const ToastNotification = ({
  overrideClassName,
  intl,
  msg,
  variant,
  closeNotification,
  index,
  actionLabel,
  onAction,
  viewPortHeight,
  setNotificationHeight,
  id,
  notificationHeight,
  shouldUseMobileModernViewer,
  overrideParentStyle
}) => {
  const toastRef = React.useRef();
  React.useEffect(() => {
    setNotificationHeight(id, toastRef.current.clientHeight);
  }, [id]);
  return (
    <span
      ref={toastRef}
      style={{
        transform: `translateX(-50%) translateY(${viewPortHeight - ((index + 1) * 16 + notificationHeight)}px)`,
        ...overrideParentStyle
      }}
      className={Styles.Notification}
      data-testid="toast-banner"
    >
      <Toast
        className={classNames(
          shouldUseMobileModernViewer ? Styles.NotificationToastMobile : Styles.NotificationToast,
          overrideClassName
        )}
        variant={variant}
        closable
        closeOnAction
        onClose={closeNotification}
        onAction={onAction}
        actionLabel={actionLabel}
      >
        {typeof msg === "string" ? intl.formatMessage({ id: msg }) : msg}
      </Toast>
    </span>
  );
};

export default ToastNotification;
